export default {
	start: {
		title: "KI-Plattform",
		tips: "Verwandeln Sie Scrollen in Verdienst! Tägliche Auszahlungen mit nur einem Tippen – Ihr Telefon, Ihre Geldmaschine!"
	},
	login: {
		tips: "Sie haben kein Konto?",
		Signup: "Registrieren",
		logIn: "Anmelden",
		Remember: "Angemeldet bleiben",
		form: {
			label: ["Benutzername/Telefon", "Passwort"]
		},
		forgotPassword: "Passwort vergessen?",
		contactSupport: "Support kontaktieren",
		title: "Konto erstellen",
		content: ["Benötigen Sie ein Konto?", "Hier Konto erstellen"]
	},
	register: {
		form: {
			label: [
				"Benutzername",
				"Telefon",
				"Transaktionspasswort",
				"Anmeldepasswort",
				"Anmeldepasswort bestätigen",
				"Geschlecht",
				"Einladungscode",
				"E-Mail",
				"Verifizierungscode"
			],
			rule: {
				Username: "Benutzername muss zwischen 4 und 10 Zeichen lang sein",
				Email: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
				Phone: "Telefonnummer muss mindestens 4 Ziffern lang sein",
				ConfirmLoginPassword: "Passwörter stimmen nicht überein",
				TradingPassword: "Transaktionspasswort muss mindestens 6 Ziffern lang sein",
				LoginPassword: "Anmeldepasswort muss mindestens 6 Ziffern lang sein"
			}
		},
		sendMsg: "Code gesendet! Bitte überprüfen Sie Ihre Nachrichten.",
		agree: ["Ich stimme den {0} zu", "Datenschutzhinweisen, MSA", "und", "Nutzungsbedingungen"],
		content: [
			"Erstellen Sie Ihr kostenloses Konto",
			"Bereits ein Konto?",
			"Hier anmelden",
			"Konto erstellen",
			"Durch Fortfahren stimmen Sie unseren Bedingungen zu"
		]
	}
};
